/* eslint-disable */
import {
    Card,
    CardContent,
    CircularProgress,
    Grid,
    RACTable,
    RACTableCell,
    RACTableRow,
    Typography,
} from '@rentacenter/racstrap';
import React, { useContext } from 'react';
import { CostBasedPricingContext } from './CostBasedPricingContext';
import { CostBasedPricingStyles } from '../Styles/CostBasedPricing';
import { sortArray } from '../../../constants/constants';
import { ReactComponent as NorecordsIcon } from "../../../assets/images/No-records.svg";
import { ReactComponent as Alert } from "../../../assets/images/Alert.svg";
import { ReactComponent as EditIcon } from "../../../assets/images/Edit Icon.svg";
import ReactPaginate from 'react-paginate';
import { ReactComponent as SortIconDown } from "../../../assets/images/sort-icon.svg";
import { ReactComponent as SortIconUp } from "../../../assets/images/sort-icon-up.svg";
import { CostPricingRuleDetail, Headers } from '../../shared/interface/CostBasedPricingInterface';

export default function CostBasedPricingGrid(props?: any) {
    const classes = CostBasedPricingStyles();
    const { pageDisplay, loader, costBasedPricingGridContent, setFormProps,
        setDisplayForm, gridHeaders, setGridHeaders, setCostBasedPricingGridContent,
        totalRowCount, pageNumber, setPageNumber, pageCount, searchCostBasedPricingDetails,
        userInfo, setHandlePopup, errorMessage, setErrorMessage
    } = useContext(CostBasedPricingContext);

    const formatDate = (dateStr: string) => {
        const [year, month, day] = dateStr.split('-');
        return `${month}/${day}/${year}`;
    };

    function editRow(obj: CostPricingRuleDetail) {
        const props = {
            zone: obj.zoneNumber || '',
            department: obj.departmentNumber || '',
            subdepartment: obj.subdepartmentNumber || '',
            bracket: obj.bracketNumber || '',
            startDate: obj.startDate || '',
            endDate: obj.endDate || '',
            publishPriceForExisitingRMS: '',
            publishPriceWhenCostChanges: '',
            schedule: '',
            minRatePct: returnFloat(obj.minRatePct),
            maxRatePct: returnFloat(obj.maxRatePct),
            minRateNew: obj.minRateNew || '',
            maxRateNew: obj.maxRateNew || '',
            minRateUsed: obj.minRateUsed || '',
            maxRateUsed: obj.maxRateUsed || '',
            turns: returnFloat(obj.turn),
            termMax: obj.termMax || '',
            initialAmount: returnFloat(obj.initialAmount),
            growth: returnFloat(obj.growth),
            lineShiftLr: returnFloat(obj.lineShiftLR),
            lineShiftUd: returnFloat(obj.lineShiftUD),
            usedRateAdjustment: obj.usedRateAdj || ''
        };
        setFormProps(props)
        setDisplayForm(true)
        setErrorMessage({
            ...errorMessage,
            startDate: '',
            endDate: '',
            minRatePct: '',
            maxRatePct: '',
            minRateNew: '',
            maxRateNew: '',
            minRateUsed: '',
            maxRateUsed: '',
            termMax: ''
        })
    }

    function returnValue(value: string | null, type?: any) {
        if (type == 'publishFlag') {
            return value ? value == 'YES' ? 'Yes' : value == 'NO' ? 'No' : value : '-'
        } else if (type == 'dollar') {
            return value ? `$${value}` : '-'
        } else if (type == 'decimel') {
            return value ? parseFloat(value).toString() : '-'
        } else if (type == 'date') {
            return value ? formatDate(value) : '-'
        }
        return value ? value : '-'
    }

    const returnFloat = (value: string) => value ? parseFloat(value).toString() : '';

    const renderCostBasedPricingTableHeadFn = () => (
        <>
            {gridHeaders.map((item: Headers, index: number) => {
                return (
                    <RACTableCell>
                        {" "}
                        {item.isSortable == true ? (
                            <a
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    sortArray(
                                        gridHeaders[index].key,
                                        index,
                                        gridHeaders,
                                        costBasedPricingGridContent,
                                        (item.key == 'endDate' || item.key == 'startDate') ? 'date' :
                                            item.key == 'publishOnCostChangeFlag' ? 'string' : 'number',
                                        setGridHeaders,
                                        setCostBasedPricingGridContent
                                    );
                                }}
                            >
                                {" "}
                                {item.heading + " "}{" "}
                                {item.isSorted == true ? (
                                    item.sortDirection == "DESC" ? (
                                        <SortIconUp className={classes.ml2} />
                                    ) : (
                                        <SortIconDown className={classes.ml2} />
                                    )
                                ) : null}
                            </a>
                        ) : (
                            item.heading + " "
                        )}{" "}
                    </RACTableCell>);
            })}
        </>
    );
    const renderCostBasedPricingTableContentFn = () => (
        <>
            {loader.contentLoader ? (
                <RACTableRow>
                    <Grid className={classes.gridLoader}>
                        <Grid className={classes.textSpaceNorecords}>
                            <Grid className={classes.textcenterImage}>
                                <CircularProgress />
                            </Grid>
                        </Grid>
                    </Grid>
                </RACTableRow>
            ) : null}
            {pageDisplay == 200 ? costBasedPricingGridContent?.map((obj: CostPricingRuleDetail, index: number) => {
                return (
                    <RACTableRow key={index} className={classes.whitebackground} style={{ width: '100%' }}>
                        <RACTableCell>{returnValue(obj?.zoneNumber)}</RACTableCell>
                        <RACTableCell>{returnValue(obj?.departmentName)}</RACTableCell>
                        <RACTableCell>{returnValue(obj?.subdepartmentName)}</RACTableCell>
                        <RACTableCell>{returnValue(obj?.bracketName)}</RACTableCell>
                        <RACTableCell>{returnValue(obj?.minRatePct, 'decimel')}</RACTableCell>
                        <RACTableCell>{returnValue(obj?.maxRatePct, 'decimel')}</RACTableCell>
                        <RACTableCell>{returnValue(obj?.minRateNew, 'dollar')}</RACTableCell>
                        <RACTableCell>{returnValue(obj?.maxRateNew, 'dollar')}</RACTableCell>
                        <RACTableCell>{returnValue(obj?.minRateUsed, 'dollar')}</RACTableCell>
                        <RACTableCell>{returnValue(obj?.maxRateUsed, 'dollar')}</RACTableCell>
                        <RACTableCell>{returnValue(obj?.turn, 'decimel')}</RACTableCell>
                        <RACTableCell>{returnValue(obj?.termMax)}</RACTableCell>
                        <RACTableCell>{returnValue(obj?.initialAmount, 'decimel')}</RACTableCell>
                        <RACTableCell>{returnValue(obj?.growth, 'decimel')}</RACTableCell>
                        <RACTableCell>{returnValue(obj?.lineShiftLR, 'decimel')}</RACTableCell>
                        <RACTableCell>{returnValue(obj?.lineShiftUD, 'decimel')}</RACTableCell>
                        <RACTableCell>{returnValue(obj?.usedRateAdj, 'dollar')}</RACTableCell>
                        <RACTableCell>{returnValue(obj?.publishOnCostChangeFlag, 'publishFlag')}</RACTableCell>
                        <RACTableCell>{returnValue(obj?.startDate, 'date')}</RACTableCell>
                        <RACTableCell>{returnValue(obj?.endDate, 'date')}</RACTableCell>
                        <RACTableCell style={{
                            width: "42px",
                            height: "45px",
                            cursor: "pointer",
                        }} >
                            <EditIcon onClick={() => {
                                if (userInfo.hasEditAccess) {
                                    editRow(obj)
                                } else {
                                    setHandlePopup({ isOpen: true, Content: 'This feature is currently restricted to this User', index: 0, type: 'error' });
                                }
                            }} />
                        </RACTableCell>
                    </RACTableRow>
                )
            }) : pageDisplay == 204 ? (
                <RACTableRow>
                    <Grid className={classes.gridLoader}>
                        <Grid className={classes.textSpaceNorecords}>
                            <Grid className={classes.textcenterImage1}>
                                <NorecordsIcon />
                                <Typography> No Records Found !</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </RACTableRow>
            ) : pageDisplay == 400 || pageDisplay == 500 ? (
                <RACTableRow>
                    <Grid className={classes.gridLoader}>
                        <Grid className={classes.textSpaceNorecords}>
                            <Grid className={classes.textcenterImage1}>
                                <Alert style={{ width: '30px', height: '30px' }} />
                                <Typography> Something Went Wrong !</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </RACTableRow>
            ) : null}
        </>
    );

    const renderTable = () => (
        <>
            <RACTable
                renderTableHead={renderCostBasedPricingTableHeadFn}
                renderTableContent={renderCostBasedPricingTableContentFn}
                style={{
                    width: "100%",
                    whiteSpace: "nowrap",
                }}
                className={classes.pricingGrid}
            />
        </>
    );

    const handlePageClick = (event: any) => {
        setPageNumber(event.selected);
        searchCostBasedPricingDetails((event.selected + 1).toString());
    };

    return (
        <Grid container md={12}>
            <Card style={{ borderRadius: '12px', marginBottom: '4%', position: 'relative', width: '100%' }}>
                <CardContent style={{ paddingBottom: '0px', paddingRight: '30px' }}>
                    <Grid
                        style={{
                            width: "100%",
                            overflowX: "auto",
                            maxHeight: "63vh",
                            minHeight: loader.contentLoader ? '38vh' : '61vh'
                        }}
                    >
                        {renderTable()}
                    </Grid>
                    {totalRowCount ? (<Grid className={` ${classes.textRight}`}>
                        <Grid className={`${classes.floatLeft}`}>

                            <Typography>
                                # of Records:&nbsp;
                                {pageNumber == 0
                                    ? totalRowCount < 25 ? totalRowCount : 25 * 1
                                    : (pageNumber + 1) == pageCount
                                        ? totalRowCount
                                        : (pageNumber + 1) * 25}
                                /{totalRowCount}
                            </Typography>
                        </Grid>

                        <ReactPaginate
                            nextLabel=">"
                            onPageChange={handlePageClick}
                            pageCount={pageCount}
                            pageRangeDisplayed={3}
                            marginPagesDisplayed={0}
                            disableInitialCallback={true}
                            previousLabel="<"
                            breakLabel=""
                            initialPage={pageNumber}
                            pageClassName={classes.pagination}
                            pageLinkClassName={classes.pagelink}
                            previousLinkClassName={
                                pageNumber === 0
                                    ? classes.paginationprevnextdisable
                                    : classes.paginationprevnext
                            }
                            nextLinkClassName={
                                pageNumber === pageCount - 1
                                    ? classes.paginationprevnextdisable
                                    : classes.paginationprevnext
                            }
                            breakClassName={classes.pagination}
                            breakLinkClassName={classes.pagination}
                            containerClassName={classes.pagination}
                            activeClassName={classes.pageactive}
                            forcePage={pageNumber === 0 ? 0 : undefined}
                        />

                    </Grid>) : null}
                </CardContent>
            </Card>
        </Grid>
    );
}
